# Generated by https://pagedraw.io/pages/5249
React = require 'react'
Studentscard = require './studentscard'
Individualcard = require './individualcard'
Companycard = require './companycard'


render = ->
    React.createElement("div", {"style": ({"display": "flex", "flexDirection": "column", "flexGrow": "1"})},
        React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
            
            
            * {
                box-sizing: border-box;
            }
            
            body {
                margin: 0;
            }
            
            button:hover {
                cursor: pointer;
            }
            
            a {
                text-decoration: none;
                color: inherit;
            }
            
            .pd-onhover-parent >.pd-onhover {
                display: none;
            }
            
            .pd-onhover-parent:hover > * {
                display: none;
            }
            
            .pd-onhover-parent:hover > .pd-onhover {
                display: flex;
            }
            
            .pd-onactive-parent > .pd-onactive {
                display: none;
            }
            
            .pd-onactive-parent:active > * {
                display: none;
            }
            
            .pd-onactive-parent:active > .pd-onactive {
                display: flex;
            }
            
            .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                display: none;
            }
        """)}),  
        React.createElement("div", {"style": ({"display": "flex", "flexShrink": "0"})},
            React.createElement("div", {"style": ({"flexShrink": "0", "display": "flex", "flexDirection": "column", "minWidth": 348})},
                React.createElement(Studentscard, null) 
            ),
            React.createElement("div", {"style": ({"flexShrink": "0", "marginLeft": 33, "display": "flex", "flexDirection": "column", "minWidth": 348})},
                React.createElement(Individualcard, null) 
            ),
            React.createElement("div", {"style": ({"flexShrink": "0", "marginLeft": 33, "display": "flex", "flexDirection": "column", "minWidth": 348})},
                React.createElement(Companycard, null) 
            )
        )
    )

module.exports = (props) -> render.apply({props})



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/pricingcards.cjsx